import React, { lazy } from 'react';
import { inject, observer } from 'mobx-react';
import { hot } from 'react-hot-loader/root'; // eslint-disable-line import/no-extraneous-dependencies
import { Redirect } from 'react-router-dom';

import { routes } from 'routing';

const MasterDashboard = lazy(() => import('components/master'));

const DashboardScene = inject('Account')(observer(({ Account }) => {
  if (!Account.isAuthorized) {
    return <Redirect to={routes.auth} />;
  } else if (Account.currentDistributor.distributorRole !== 'MASTER_ACCOUNT') {
    return (
      <Redirect to={routes.dashboard} />
    )
  }

  return <MasterDashboard />;
}));

export default hot(DashboardScene);
